import React from 'react';
import { useSearchParams } from 'react-router-dom';

export default function DetallePagos(props) {
    const [searchParams] = useSearchParams();
    const tk = searchParams.get('tk');

    // Construimos la URL del iframe
    const iframeUrl = `https://pagos.cooeprouasd.net/detallepago.aspx?tk=${tk}`;

    const containerStyle = {
        position: 'fixed', // Se posiciona respecto a la ventana
        top: 0,
        left: 0,
        width: '100vw',    // 100% del ancho
        height: '100vh',   // 100% del alto
        border: 'none',
        overflow: 'hidden',
        zIndex: 9999       // Asegura que esté por encima de todo
    };

    if (!tk) {
        return (
            <div style={{ padding: '20px', textAlign: 'center' }}>
                <h2>Error: Token de pago no encontrado.</h2>
                <p>Por favor, verifique el enlace de su correo electrónico.</p>
            </div>
        );
    }

    return (
        <iframe
            src={iframeUrl}
            style={containerStyle}
            title="Detalle de Pago"
            allow="payment" // Permite APIs de pago si el sitio del iframe las usa
        />
    );
}